/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PersonCaseStatus {
    POSSIBLE_CASE = 'possibleCase',
    PROBABLE_CASE = 'probableCase',
    CONFIRMED_CASE = 'confirmedCase',
}
